const FEET = 3.281
const INCH = 25.4

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0)
  return Math.round(value * multiplier) / multiplier
}

function roundByNum(num, rounder) {
  var multiplier = 1 / (rounder || 0.5)
  return Math.round(num * multiplier) / multiplier
}


export default {
  methods: {
    MetricToFeet: (value)  => {
      return round(value * FEET, 1)
    },
    FeetsToMeters: (value) => {
      var meters = round(value / FEET, 2)
      return roundByNum(meters, 0.5)
    },
    MelimeterToInches: (value) => {
      return round(value / INCH, 2)
    },
    InchesToMelimeters:(value)  => {
      return round(value * INCH, 0)
    },
  },
}
